import type { ReactNode } from 'react';

export const symbol_game_button_zl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m319-385 128-190q1-2 3-25.03 0-7.97-5.79-13.97-5.79-6-14.48-6H284q-10.12 0-16.56 6.42-6.44 6.41-6.44 16.5 0 10.08 6.44 16.58 6.44 6.5 16.56 6.5h106L263-384q-1 1-3 25.24 0 7.76 6 13.76t14 6h149.75q10.23 0 16.74-6.42 6.51-6.41 6.51-16.5 0-10.08-6.44-16.58-6.44-6.5-16.56-6.5H319Zm258 0v-209.64q0-11.36-7-18.36t-18-7q-11 0-18 7t-7 18v226q0 12.75 8.63 21.37Q544.25-339 557-339h120q10.12 0 16.56-6.42 6.44-6.41 6.44-16.5 0-10.08-6.44-16.58-6.44-6.5-16.56-6.5H577Zm303-355v426q0 63.52-44.5 108.76T727-160H233q-64 0-108.5-45.24T80-314v-426q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740Zm-60 0H140v426q0 38.77 27 66.39Q194-220 233-220h494q39 0 66-27.61 27-27.62 27-66.39v-426Zm0 0H140h680Z"
		/>
	</svg>
);
